import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as cafeActions from '../../../redux/cafes/actions';
import Spin from '../../../components/loading';
import ImageUploader from '../../../components/imageUploader';
import { dataGenerator, domManipulator } from '../../../utils';
import ShowForPermission from '../../../components/ShowForPermission';
import enums from '../../../enums';

class EditCafeImages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoUrl: '',
      locationTableUrl: '',
      locationTableFileName: '',
      logoFileName: '',
      cafeImages: [],
    };
  }
  componentDidMount() {
    let { cafeImages, logoUrl, locationTableUrl } = this.props.location;
    if (logoUrl) {
      this.setState(state => {
        state.logoUrl = logoUrl;
        return '';
      });
    }
    if (cafeImages && cafeImages.length > 0) {
      this.setState(state => {
        state.cafeImages = cafeImages.map(item => ({
          ...item,
          key: dataGenerator.generateKey('cafeImages'),
        }));
        return '';
      });
    }
    if (locationTableUrl) {
      this.setState(state => {
        state.locationTableUrl = locationTableUrl;
        return '';
      });
    }
  }

  onUploadLogoSuccess = uploadedFile => {
    this.setState(() => ({
      logoFileName: uploadedFile.fileName,
      logoUrl: uploadedFile.url,
    }));
  };

  deleteLogo = _ => {
    this.setState(() => ({
      logoUrl: null,
      logoFileName: null,
    }));
  };

  onUploadLocationTableSuccess = uploadedFile => {
    this.setState(() => ({
      locationTableFileName: uploadedFile.fileName,
      locationTableUrl: uploadedFile.url,
    }));
  };

  deleteLocationTable = _ => {
    this.setState(() => ({
      locationTableUrl: null,
      locationTableFileName: null,
    }));
  };

  onUploadCafeImagesSuccess = uploadedCafeImages => {
    this.setState(() => ({
      cafeImages: [...this.state.cafeImages, ...uploadedCafeImages],
    }));
  };

  deleteCafeImage = key => {
    const filteredCafeImages = this.state.cafeImages.filter(x => x.key !== key);
    this.setState(() => ({
      cafeImages: filteredCafeImages,
    }));
  };

  onSubmit = () => {
    const {
      cafeImages,
      logoUrl,
      logoFileName,
      locationTableUrl,
      locationTableFileName,
    } = this.state;

    let imagesAndLogoObject = {
      cafeImages,
      logoUrl,
      logoFileName,
      locationTableUrl,
      locationTableFileName,
    };

    this.props.updateCafeImagesAndLogoForAdmin(imagesAndLogoObject).then(() => {
      const {
        updateCafeImagesAndLogoForAdminError,
        updateCafeImagesAndLogoForAdminFailed,
        updateCafeImagesAndLogoForAdminMessage,
      } = this.props;
      if (
        updateCafeImagesAndLogoForAdminFailed == false &&
        updateCafeImagesAndLogoForAdminError == false &&
        updateCafeImagesAndLogoForAdminMessage == null
      ) {
        this.props.history.push('/my-cafe-info');
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  render() {
    let {
      updateCafeImagesAndLogoForAdminLoading,
      updateCafeImagesAndLogoForAdminError,
      updateCafeImagesAndLogoForAdminFailed,
      updateCafeImagesAndLogoForAdminMessage,
    } = this.props;

    let { cafeImages, logoUrl, locationTableUrl } = this.state;

    return (
      <div className='col-12 my-3'>
        <Spin spinner={updateCafeImagesAndLogoForAdminLoading}>
          <div className='col-12 d-flex justify-content-between align-items-center'>
            <h3>{locales('titles.editCafeImagesAndLogo')}</h3>
            <div>
              <ShowForPermission
                permission={enums.PERMISSIONS.values.UPLOAD_CAFE_IMAGES}
              >
                <button
                  onClick={this.onSubmit}
                  className='btn btn-success w-5 mx-1'
                >
                  <i className='fa fa-save' />
                  {locales('labels.save')}
                </button>
              </ShowForPermission>
              <button
                onClick={() => this.props.history.push('/my-cafe-info')}
                className='btn btn-default w-5 mx-1'
              >
                <i className='fa fa-reply' />
                {locales('labels.cancel')}
              </button>
            </div>
          </div>

          {updateCafeImagesAndLogoForAdminError && (
            <div className='alert alert-danger'>
              {locales('messages.server.error')}
            </div>
          )}
          {updateCafeImagesAndLogoForAdminFailed && (
            <div className='alert alert-danger'>
              {updateCafeImagesAndLogoForAdminMessage}
            </div>
          )}
          <ShowForPermission
            permission={enums.PERMISSIONS.values.UPLOAD_CAFE_IMAGES}
          >
            <div>
              <ImageUploader
                placeholder={locales('fields.cafe.logo.image')}
                actionUrl={`${API_ENDPOINT}/v1/general/upload-cafe-logo`}
                imageFile={logoUrl}
                isMulti={false}
                onUploadSuccess={this.onUploadLogoSuccess}
                deleteImage={this.deleteLogo}
                fileName={this.state.logoFileName}
              />
            </div>
            <ImageUploader
              placeholder={'انتخاب تصویرهای کافه'}
              actionUrl={`${API_ENDPOINT}/v1/cafe/upload-cafe-images`}
              imageFile={cafeImages}
              isMulti={true}
              onUploadSuccess={this.onUploadCafeImagesSuccess}
              deleteImage={this.deleteCafeImage}
              isDisabled={cafeImages.length >= 3}
            />
            <ImageUploader
              placeholder={locales('fields.table.location.image')}
              actionUrl={`${API_ENDPOINT}/v1/general/upload-location-table`}
              imageFile={locationTableUrl}
              isMulti={false}
              onUploadSuccess={this.onUploadLocationTableSuccess}
              deleteImage={this.deleteLocationTable}
              fileName={this.state.locationTableFileName}
            />
          </ShowForPermission>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    updateCafeImagesAndLogoForAdminLoading:
      state.cafesReducer.updateCafeImagesAndLogoForAdminLoading,
    updateCafeImagesAndLogoForAdminError:
      state.cafesReducer.updateCafeImagesAndLogoForAdminError,
    updateCafeImagesAndLogoForAdminMessage:
      state.cafesReducer.updateCafeImagesAndLogoForAdminMessage,
    updateCafeImagesAndLogoForAdminFailed:
      state.cafesReducer.updateCafeImagesAndLogoForAdminFailed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateCafeImagesAndLogoForAdmin: imagesAndLogoObject =>
      dispatch(
        cafeActions.updateCafeImagesAndLogoForAdmin(imagesAndLogoObject),
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCafeImages);
